import { webPortalApi } from '#config/web-portal-api';
import { getAuth, getTimeZone } from '#helper';

export const getDeeplink = (shipmentId, measurementSystem) =>
  fetch(webPortalApi.buildApiUrl(`shipment/${shipmentId}/deeplink`), {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getAuth()}`,
      Timezone: getTimeZone(),
      'Content-Type': 'application/json'
    }
  })
    .then(response => {
      if (!response.ok) {
        return Promise.reject(
          new Error(`HTTP ${response.status}`)
        );
      }

      return response.json();
    })
    .then(({ token }) => {
      const deepLinkURL = `${window.location.origin}/link/shipment/${token}?system=${measurementSystem}`;

      return new Blob([deepLinkURL], { type: 'text/plain' });
    });
